import * as Sentry from '@sentry/react'

export type ReviewEvent = {
  type:
    | 'review_step_update'
    | 'review_session_status'
    | 'review_discovery_done'
    | 'review_stream'
    | 'review_human_question'
    | 'ping'
    | 'error'
  session_id?: number
  repo?: string
  pr_number?: number
  step?: string
  status?: string
  detail?: string
  error?: string
  review_summary?: string
  review_severity?: string
  human_question?: string
  diagnosis?: string
  ci_passed?: boolean
  mergeable?: boolean
  is_re_review?: boolean
  fix_summary?: string
  ci_timed_out?: boolean
  content?: string
  tool_name?: string
  tool_input?: string
  tool_result?: string
  total_prs?: number
  merged_prs?: number
  skipped_prs?: number
  failed_prs?: number
  repos?: Record<string, number>
  message?: string
}

export function createReviewSocket(
  onEvent: (event: ReviewEvent) => void,
  onClose?: () => void,
) {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const ws = new WebSocket(`${protocol}//${window.location.host}/api/review/ws`)

  ws.onmessage = (e) => {
    try {
      const event: ReviewEvent = JSON.parse(e.data)
      if (event.type === 'ping') return
      if (event.type === 'error') {
        Sentry.captureMessage(`Review error: ${event.detail ?? 'Unknown'}`, 'error')
      }
      onEvent(event)
    } catch {
      console.error('Failed to parse review event:', e.data)
    }
  }

  ws.onclose = () => onClose?.()

  const close = () => ws.close()

  return { close, ws }
}
